import { render, staticRenderFns } from "./ClaimBatchProcessing.vue?vue&type=template&id=c7805f28&"
import script from "./ClaimBatchProcessing.vue?vue&type=script&lang=js&"
export * from "./ClaimBatchProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports